import React, { ReactElement, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { usePageNumberFromUrl, usePerPageValueFromUrl } from 'idsk-react-components';
import { SearchInputButton } from 'slovlex-idsk-react-components';
import { defaultPerPageValue, perPageDataArray } from '../../constants/PaginationPerPageConstants';
import useFilter from './useFilter';

interface Props {
  filterParam: string,
  label: string,
  route: string,
}

const FilterInput = ({
  filterParam, label, route,
}: Props): ReactElement => {
  const { page } = usePageNumberFromUrl('page');
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const navigate = useNavigate();

  const {
    searchText,
    setSearchText,
    resetFilterHandler,
    targetUrl,
  } = useFilter(
    page,
    perPageValue,
    filterParam,
    route,
  );

  const submitFilter = useCallback(async (): Promise<void> => {
    navigate(targetUrl);
  }, [navigate, targetUrl]);

  useEffect(() => {
    const keyDownHandler = async (e): Promise<void> => {
      if (e.key === 'Enter') {
        e.preventDefault();
        await submitFilter();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [submitFilter]);

  return (
    <SearchInputButton
      maxLength={255}
      label={label}
      searchText={searchText || ''}
      setSearchText={setSearchText}
      onButtonSubmit={submitFilter}
      onClearSearch={resetFilterHandler}
      width="one-quarter"
    />
  );
};

export default FilterInput;
